// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SZDD","colBig":"styles_colBig__1lhaY","colSmall":"styles_colSmall__2w1zR"};